import { Typography, Grid, Box } from "@material-ui/core";

import { ShaDowBox } from "../../../../../components/boxes";
import { Icon } from "../../../../../components/base";
import DoubleCircleImg from "../../../../../assets/images/icons/double-circle.svg";
import TenantImg from "../../../../../assets/images/icons/tenant.svg";
import SubMeterAndPublicImg from "../../../../../assets/images/icons/sub-meter-and-public.svg";

export const MeterPerUnit = () => {

  return (
    <ShaDowBox fullHeight>
      <Box style={{ padding: "24px 24px 64px" }}>
        <Typography variant="h4">Meter per unit</Typography>
        <Grid container style={{ marginTop: 50 }}>
          <Grid item sm={6} style={{ borderRight: "1px solid rgba(88, 88, 88, 0.25)", paddingBottom: 20 }}>
            <Grid container style={{ width: 102, margin: "0 auto 30px" }}>
              <Grid item xs={6} style={{ marginBottom: 10 }}>
                <Icon src={DoubleCircleImg} />
              </Grid>
              <Grid item xs={6} style={{ textAlign: "center" }}>
                <Icon src={DoubleCircleImg} />
              </Grid>
              <Grid item xs={6}>
                <Icon src={DoubleCircleImg} />
              </Grid>
              <Grid item xs={6} style={{ textAlign: "center" }}>
                <Icon src={DoubleCircleImg} />
              </Grid>
            </Grid>
            <Grid container justifyContent="center" alignItems="baseline">
              <Typography style={{ marginRight: 5 }}>Total</Typography>
              <Typography variant="h2">80</Typography>
            </Grid>
            <Typography style={{ textAlign: "center" }}>Sub-Meters</Typography>
          </Grid>
          <Grid container item sm={6} justifyContent="center" style={{ paddingBottom: 20 }}>
            <Grid container alignItems="center" justifyContent="center">
              <Icon
                src={TenantImg}
                style={{
                  marginRight: 20
                }}
              />
              <Box>
                <Typography style={{ fontWeight: 700 }}>
                  75 meters
                </Typography>
                <Typography>
                  owned by <br/> tenants
                </Typography>
              </Box>
            </Grid>
            <Grid container alignItems="center" justifyContent="center">
              <Icon
                src={SubMeterAndPublicImg}
                style={{
                  width: 50,
                  height: 50,
                  marginRight: 20
                }}
              />
              <Box>
                <Typography style={{ fontWeight: 700 }}>
                  75 meters
                </Typography>
                <Typography>
                  owned by <br/> tenants
                </Typography>
              </Box>
            </Grid>
          </Grid>
        </Grid>
      </Box>
    </ShaDowBox>
  )
}
